import { render, staticRenderFns } from "./ResearchGenesTrackVector.vue?vue&type=template&id=58c20dda&"
import script from "./ResearchGenesTrackVector.vue?vue&type=script&lang=js&"
export * from "./ResearchGenesTrackVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c20dda')) {
      api.createRecord('58c20dda', component.options)
    } else {
      api.reload('58c20dda', component.options)
    }
    module.hot.accept("./ResearchGenesTrackVector.vue?vue&type=template&id=58c20dda&", function () {
      api.rerender('58c20dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchGenesTrackVector.vue"
export default component.exports